import type { CapabilityRegistry } from "../lib/api";

export const object = (value: unknown): Record<string, unknown> => value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
export function channelLabels(registries: CapabilityRegistry[]): Record<string, string> {
  const channels = registries.find(registry => registry.kind === "channels");
  return channels && !channels.problem ? Object.fromEntries(channels.entries.flatMap(entry => {
    const title = object(entry.spec).display_name;
    return typeof title === "string" && title.trim() ? [[entry.key, title]] : [];
  })) : {};
}
/** Only explicitly titled schema fields are shown; schema secrets stay private. */
export function declaredValue(value: unknown, schema: Record<string, unknown>, depth = 0): string | null {
  if (schema.writeOnly === true || schema.secret === true || depth > 4) return null;
  const choice = (Array.isArray(schema.oneOf) ? schema.oneOf : []).map(object).find(option => option.const === value);
  if (typeof choice?.title === "string") return choice.title;
  const labels = object(schema.choice_labels);
  if (typeof labels[String(value)] === "string") return labels[String(value)] as string;
  if (typeof value === "boolean") return value ? "是" : "否";
  if (typeof value === "number" && Number.isFinite(value)) return schema.format === "percent" ? `${Math.round(value * 100)}%` : String(value);
  if (typeof value === "string") return value.trim() || null;
  if (Array.isArray(value)) {
    const items = object(schema.items);
    return value.map(item => declaredValue(item, items, depth + 1) || "内容未读完整").join("；") || null;
  }
  if (value && typeof value === "object") {
    const row = object(value);
    const required = Array.isArray(schema.required) ? schema.required : [];
    const properties = object(schema.properties);
    const alternatives = (Array.isArray(schema.anyOf) ? schema.anyOf : []).map(object);
    if (alternatives.length && !alternatives.some(option => Array.isArray(option.required) && option.required.every(key => typeof key === "string" && key in row)))
      return "内容未读完整，请核对原请求";
    const missing = required.filter(key => typeof key === "string" && !(key in row));
    if (missing.length) return `尚未提供：${missing.map(key => object(properties[String(key)]).title || "必填内容").join("、")}`;
    const fields = Object.entries(properties).flatMap(([key, raw]) => {
      const field = object(raw);
      if (typeof field.title !== "string" || !field.title.trim() || !(key in row)) return [];
      const said = declaredValue(row[key], field, depth + 1);
      return said ? [`${field.title}：${said}`] : [];
    });
    return fields.join("；") || null;
  }
  return null;
}
